import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'app/components/Icon';
import classNames from 'classnames';
import { NavLink, useLocation } from 'react-router-dom';

export default function AsideMenuToggle({ title, icon, elements }) {
  const location = useLocation();
  const { pathname = [] } = location;

  const active = elements.filter((element) => element.url === pathname).length;

  return (
    <li className="menu-item menu-item-submenu">
      <a
        className={classNames('menu-link menu-toggle', {
          active
        })}
        href="#toggle"
      >
        <span className="menu-icon">
          <Icon icon={icon} prefix="fad" size="lg" />
        </span>
        <span className="menu-text">{title}</span>
        <i className="menu-arrow" />
      </a>
      <div className="menu-submenu">
        <ul className="menu-subnav">
          {elements.map((element) => (
            <li
              key={element.url}
              className={classNames('menu-item', {
                'menu-item-active': element.url === pathname
              })}
            >
              <NavLink
                className={classNames('menu-link children', {
                  active: element.url === pathname
                })}
                to={element.url}
                data-icon-src={element.icon}
                onClick={() =>
                  document.getElementById('kt_aside_mobile_toggle').click()
                }
              >
                <i className="menu-bullet menu-bullet-dot">
                  <span />
                </i>
                <p className="menu-text">{element.title}</p>
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </li>
  );
}

AsideMenuToggle.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  elements: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      title: PropTypes.string
    })
  ).isRequired
};
